import { AnimatePresence, motion as Motion } from 'framer-motion'
import { ArrowDown } from 'lucide-react'

import { cn } from '../../lib/utils'
import { Button } from '../ui/button'

const ScrollToBottomButton = ({ visible, onClick }) => (
  <AnimatePresence>
    {visible && (
      <Motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.2 }}
      >
        <Button
          onClick={onClick}
          variant="secondary"
          className={cn(
            'size-9',
            'transition-colors duration-200',
            'border border-black/10 dark:border-white/10',
            'bg-white/70 backdrop-blur-sm dark:bg-black/10',
            'dark:text-white/80',
            'absolute bottom-8 end-1/2 z-10 flex translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-clip-padding sm:bottom-9',
            'hover:bg-gray-100 dark:hover:bg-gray-800',
            'hover:text-black/90 dark:hover:text-white',
            'active:bg-black/15 dark:active:bg-white/20',
            'hover:opacity-100',
          )}
        >
          <ArrowDown className="icon-md text-foreground" />
        </Button>
      </Motion.div>
    )}
  </AnimatePresence>
)

export default ScrollToBottomButton
